module.exports = __webpack_public_path__ + "static/media/facebook.700dba70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facebook.svg
// module id = 14
// module chunks = 0